import { defineStore, acceptHMRUpdate } from "pinia";
import { brogglBack } from "../axios.js";
import router from "../router/index.js";
import { newProjects2 } from "../assets/variables.js";
import { useClientStore } from "./client";
import { useUserStore } from "./user";
import { useEntriesStore } from "./entries";
import { useProductStore } from "./product.js";
import { BAsSpecificTasks } from "../assets/variables.js";
import dayjs from "dayjs";

export const useFormStore = defineStore("form", {
  state: () => ({
    error: null,
    parameters: {
      entryId: "",
      client: "",
      project: "",
      task: "",
      duration: 0.25,
      description: "",
      hours: 0,
      minutes: 15,
      date: new Date(),
      testId: null,
      jiraType: "BD-",
      jiraIdNumber: "",
      jiraId: "",
      entity: null,
      scope: "Web Exp & Perso",
      productId: null,
      duplicate: null,
      campaignTime: 0,
      manDays: null,
      SFEntryId: null,
    },
    manDayDisable: false,
    errorManDay: "",
    duplicateField: false,
    manDayVisible: false,
    forceManDayValue: "",
    errorForm: "",
    displayDuration: "",
    startTime: new Date(),
    timer: 0,
    projects: newProjects2,
    productDisable: false,
    entities: [],
    products: [],
    displayedDuration: 0,
    testIdResults: false,
    fetchEntryByTestIdResult: false,
    fetchedEntryByTestId: {},
    isIdInClientsList: false,
    productListKey: 0,
    recurringActivities: false,
    entrySended: true,
    userEntriesIsLoaded: true,
    timerState: "Off",
    duration: 0,
    testIdDisabled: false,
    isMobile: false,
  }),
  getters: {
    getError: (state) => {
      return state.error;
    },
    getParameters: (state) => {
      return state.parameters;
    },
    getManDayDisable: (state) => {
      return state.manDayDisable;
    },
    getErrorManDay: (state) => {
      return state.errorManDay;
    },
    getDuplicateField: (state) => {
      return state.duplicateField;
    },
    getManDayVisible: (state) => {
      return state.manDayVisible;
    },
    getForceManDayValue: (state) => {
      return state.forceManDayValue;
    },
    getErrorForm: (state) => {
      return state.errorForm;
    },
    getDisplayDuration: (state) => {
      return state.displayDuration;
    },
    getTimer: (state) => {
      return state.timer;
    },
    getProjects: (state) => {
      return state.projects;
    },
    getProductDisable: (state) => {
      return state.productDisable;
    },
    getEntities: (state) => {
      return state.entities;
    },
    getProducts: (state) => {
      return state.products;
    },
    getDisplayedDuration: (state) => {
      return state.displayedDuration;
    },
    getTestIdResults: (state) => {
      return state.testIdResults;
    },
    getFetchEntryByTestIdResult: (state) => {
      return state.fetchEntryByTestIdResult;
    },
    getFetchedEntryByTestId: (state) => {
      return state.fetchedEntryByTestId;
    },
    getIsIdInClientsList: (state) => {
      return state.isIdInClientsList;
    },
    getProductListKey: (state) => {
      return state.productListKey;
    },
    getRecurringActivities: (state) => {
      return state.recurringActivities;
    },
    getEntrySended: (state) => {
      return state.entrySended;
    },
    getTimerState: (state) => {
      return state.timerState;
    },
    getTestIsDisabled: (state) => {
      return state.testIdDisabled;
    },
    getIsMobile: (state) => {
      return state.isMobile;
    },
  },
  actions: {
    async fetchLastEntryByTestId(viewOrigin) {
      const userStore = useUserStore();
      this.errorForm = "";
      if (this.parameters.testId !== "") {
        try {
          const res = await brogglBack.get("/entries-last", {
            params: { testId: this.parameters.testId },
            headers: { Authorization: "Bearer " + window.$cookies.get("jwt") },
          });
          if (res.data.data !== null) {
              if (viewOrigin === "home") {
                this.errorForm = "";
                let client = res.data.data;
                this.fetchEntryByTestIdResult = userStore.isClientInFavoritesList(
                  res.data.data.clientId,
                );
                if (!this.fetchEntryByTestIdResult) {
                  this.errorForm = `This test id is already linked to ${res.data.data.clientName}. Please use the same client`;
                  return;
                }
              } else if (viewOrigin === "client") {
                this.errorForm = "";
                if (
                  parseInt(router.currentRoute.value.params.id) !==
                  parseInt(res.data.data.clientId)
                ) {
                  this.errorForm = `This test id is already linked to ${res.data.data.clientName}. Please use the same client`;
                  return;
                }
              }
              this.fetchEntryByTestIdResult = true;
              this.fetchedEntryByTestId = res.data.data;
              await this.startEntryEditFromFetchedEntry(
                res.data.data,
                viewOrigin,
              );
              this.checkIfTestMustDisabled();
          } else {
            this.errorForm = "";
          }
        } catch (err) {
          console.log(err);
        }
      }
    },
    async testIdCheck() {
      try {
        const res = await brogglBack.get("/test/TestIdCheck", {
          params: { testid: this.parameters.testId },
          headers: { Authorization: "Bearer " + window.$cookies.get("jwt") },
        });
        if (res.data !== null) {
          if (
            res.data.data.manDays > 0 &&
            this.fetchEntryByTestIdResult === false
          ) {
            this.parameters.productId = res.data.data.productId;
            this.productChange();
            this.manDayDisable = true;
            this.parameters.manDays = res.data.data.manDays;
            this.errorManDay =
              "An entry with this testId already exists in Broggl";
          }
        } else if (res.status === 401) {
          window.$cookies.set("jwt", "");
        }
      } catch (err) {
        console.log(err);
      }
    },

    async createEntry(vueEmiting) {
      this.cleanErrorMessages();
      this.entrySended = false;
      const userStore = useUserStore();
      const clientStore = useClientStore();
      let clientId = this.getClientId();
      let formValidation = await this.formValidation();
      this.computeDuration();
      if (formValidation) {
        this.replaceProductId(this.parameters.productId);
        try {
          let entityId = "";
          if (vueEmiting === "client") {
            this.entities = clientStore.entities;
          }
          this.entities.forEach((entity) => {
            if (entity.Name === this.parameters.entity) {
              entityId = entity.ID;
            }
          });
          this.parameters.date = dayjs(this.parameters.date).format(
            "YYYY-MM-DD",
          );
          let ownerName = userStore.getUserName();
          let userId = userStore.getUserId();
          let trimmmedTestid = "";
          if (
            this.parameters.testId !== "" &&
            this.parameters.testId !== null
          ) {
            trimmmedTestid = this.parameters.testId.trim();
          }
          const res = await brogglBack.post(
            "/entries/create",
            {
              frequency: 'single',
              ticketType: 'jira',
              description: this.parameters.description,
              clientId: clientId,
              testId: trimmmedTestid,
              owner: ownerName,
              userId: userId,
              productId: this.parameters.productId,
              entityId: entityId,
              date: this.parameters.date,
              duration: this.parameters.duration,
              jiraId: this.parameters.jiraId,
              scope: this.parameters.scope,
              duplicate: this.parameters.duplicate,
              manDays: this.parameters.manDays,
              task: this.parameters.task,
              project: this.parameters.project,
            },
            {
              headers: {
                Authorization: "Bearer " + window.$cookies.get("jwt"),
              },
            },
          );
          let productId = this.parameters.productId;
          let product = null;
          this.clearParameters();
          this.cleanErrorMessages();
          if (productId != null && res.data.data != null) {
            for (const item of this.products) {
              if (item.id === productId) {
                product = item;
              }
            }
            if (product !== null && res.data.data.product !== null) {
              product.use = res.data.product.use;
              product.monthly_use = res.data.product.monthly_use;
              product.productFullName = `${product.product_name} - (${product.total - product.monthly_use})`;
            }
          }
          if (vueEmiting === "client") {
            this.created = true;
            this.entrySended = true;
            await clientStore.clientReactivnessRoutine();
          } else if (vueEmiting === "home") {
            await userStore.homePageWrapper();
            this.entriesKey += 1;
            this.entrySended = true;
          }
        } catch (err) {
          this.entrySended = true;
          console.log(err);
        }
      } else {
        this.entrySended = true;
      }
    },

    async startEntryEdit(key, index, vueEmiting) {
      this.cleanErrorMessages();
      const productStore = useProductStore();
      if (this.timerState === "On") {
        var result = confirm(
          "You did not save th ongoing task, if you continue you will lose your progression. Continue ?",
        );
        if (result) {
          this.stopChrono();
        }
      }
      this.resetChrono();
      let entry = [];
      if (vueEmiting === "client") {
        entry = useEntriesStore().entries[key][index];
      } else if (vueEmiting === "home") {
        entry = useUserStore().userEntries[key][index];
      }
      this.parameters.client = entry.ClientID;
      await this.onChange(vueEmiting);
      this.productChange();
      var hours = Math.trunc(entry.Duration);
      var minutes = (entry.Duration - hours) * 60;
      this.duration = entry.Duration * 3600;
      this.displayedDuration = entry.duration * 3600;
      this.decimalDuration = entry.duration;
      this.parameters.scope = entry.Scope;
      const dateArray = entry.Date.split("-");
      var date = new Date(
        Date.UTC(dateArray[0], dateArray[1] - 1, dateArray[2]),
      );
      let jiraId = entry.Jira_id;
      if (jiraId !== "") {
        const regexp = RegExp("^([A-Z0-9]{2,8}-)([0-9]{3,6})$");
        if (regexp.test(jiraId)) {
          let match = jiraId.match(regexp);
          if (match.length >= 2) {
            this.parameters.jiraType = match[1];
            this.parameters.jiraIdNumber = match[2];
          }
        }
      }
      // this.billable = entry.billable
      this.parameters.entryId = entry.ID;

      let entryProjectTasklength = entry.ProjectTask.split(" - ").length;
      this.parameters.task = entry.ProjectTask.split(" - ")[1];
      if (entryProjectTasklength > 2) {
        for (let i = 2; i < entryProjectTasklength; i++) {
          this.parameters.task += " - " + entry.ProjectTask.split(" - ")[i];
        }
      }
      Object.keys(newProjects2).forEach((key) => {
        if (key.includes(this.getProjectNameFromEntry(entry))) {
          this.parameters.project = key;
        }
      });
      this.parameters.duration = entry.Duration;
      this.parameters.hours = hours;
      this.parameters.minutes = minutes;

      if (vueEmiting === "home") {
        await this.onChange("home");
      }

      const goodDate = new Date(key);
      date.setDate(goodDate.getDate());
      date.setMonth(goodDate.getMonth());
      this.parameters.date = date;
      this.parameters.description = entry.Description;
      this.parameters.testId = entry.TestId;
      let doesProductExist = productStore.checkIfProductExist(entry.ProductID);
      if (!doesProductExist) {
        await productStore.fetchProduct(entry.ProductID);
        this.manDayVisible = true;
      }
      this.parameters.productId = entry.ProductID;
      this.errorForm = "";
      this.oldProduct = entry.ProductId;
      if (entry.Duplicate) {
        this.parameters.productId = -2;
        this.productChange();
        this.parameters.duplicate = entry.Duplicate;
      }
      this.parameters.manDays = entry.ManDays;
      this.parameters.entity = entry.EntityName;
      this.parameters.SFEntryId = entry.SFEntryId;
      this.productChange();
    },
    async editEntry(entryId, vueEmiting) {
      this.cleanErrorMessages();
      this.entrySended = false;
      if (vueEmiting === "home") {
        this.userEntriesIsLoaded = false;
      }
      const entriesStore = useEntriesStore();
      const clientStore = useClientStore();
      const userStore = useUserStore();
      let clientId = this.getClientId();
      const userId = userStore.getUserId();
      const ownerName = userStore.getUserName();
      let formValidation = await this.formValidation();
      let entityId = null;
      this.entities.forEach((entity) => {
        if (entity.Name === this.parameters.entity) {
          entityId = entity.ID;
        }
      });
      if (formValidation) {
        this.computeDuration();
        try {
          let trimmmedTestid = "";
          if (
            this.parameters.testId !== "" &&
            this.parameters.testId !== null
          ) {
            trimmmedTestid = this.parameters.testId.trim();
          }
          this.parameters.date = dayjs(this.parameters.date).format(
            "YYYY-MM-DD",
          );
          const res = await brogglBack.patch(
            "entries/update",
            {
              frequency: 'single',
              ticketType: 'jira',
              id: entryId,
              description: this.parameters.description,
              clientId: clientId,
              testId: trimmmedTestid,
              owner: ownerName,
              userId: userId,
              productId: this.parameters.productId,
              entityId: entityId,
              date: this.parameters.date,
              duration: this.parameters.duration,
              jiraId: this.parameters.jiraId,
              scope: this.parameters.scope,
              duplicate: this.parameters.duplicate,
              manDays: this.parameters.manDays,
              task: this.parameters.task,
              project: this.parameters.project,
              SFEntryId: this.parameters.SFEntryId,
            },
            {
              headers: {
                Authorization: "Bearer " + window.$cookies.get("jwt"),
              },
            },
          );
          if (vueEmiting === "client") {
            this.clearParameters();
            this.cleanErrorMessages();
            const clientStore = useClientStore();
            this.created = true;
            this.entrySended = true;
            await clientStore.clientReactivnessRoutine();
          } else if (vueEmiting === "home") {
            this.clearParameters();
            this.cleanErrorMessages();
            await userStore.homePageWrapper();
            this.entriesKey += 1;
            this.userEntriesIsLoaded = true;
            this.entrySended = true;
          }
          this.clearParameters();
          this.cleanErrorMessages();
        } catch (err) {
          console.log(err);
        }
        this.parameters.scope = "Web Exp & Perso";
      }
    },

    async deleteEntry(entry, renderType) {
      this.cleanErrorMessages();
      const clientStore = useClientStore();
      if (renderType === "home") {
        this.userEntriesIsLoaded = false;
      } else if (renderType === "client") {
        clientStore.isReactiveRoutineDone = false;
      }
      this.checkIfViewIsMobile();
      const entriesStore = useEntriesStore();
      const userStore = useUserStore();
      let clientId = this.getClientId();
      var result = false;
      let id = entry.ID;
      if (this.isMobile) {
        result = true;
      } else {
        result = confirm("Do you really want to delete the entry ?");
      }
      if (result) {
        try {
          const res = await brogglBack.delete("/entries", {
            params: { id: id },
            headers: { Authorization: "Bearer " + window.$cookies.get("jwt") },
          });
          let product_id = entry.ProductId;
          let product = null;
          if (product_id != null && res.data.data != null) {
            for (const item of this.products) {
              if (item.ID === product_id) {
                product = item;
              }
            }
            if (product != null && res.data.data != null) {
              if (product.is_man_days) {
                product.use = res.data.product.madds_consumed;
              } else {
                product.use = res.data.product.use;
                product.monthly_use = res.data.product.monthly_use;
                product.productFullName = `${product.product_name} - (${product.total - product.monthly_use})`;
              }
            }
          }
          if (renderType === "client") {
            this.created = true;
            this.entrySended = true;
            await clientStore.clientReactivnessRoutine();
          } else if (renderType === "home") {
            userStore.homePageWrapper();
            this.entriesKey += 1;
            this.userEntriesIsLoaded = true;
          }
        } catch (err) {
          if (renderType === "home") {
            this.userEntriesIsLoaded = false;
          }
          console.log(err);
        }
        this.parameters.scope = "Web Exp & Perso";
      }
    },

    async startEntryEditFromFetchedEntry(entry, viewOrigin) {
      if (this.timerMode === "On") {
        var result = confirm(
          "You did not save the ongoing task, if you continue you will lose your progession. Continue ?",
        );
        if (result) {
          this.stopChrono();
        }
      }
      this.resetChrono();


      this.parameters.client = entry.clientId;
      
      if (Object.keys(entry).includes("Product")) {
        const productStore = useProductStore();
        productStore.products.push(entry.product);
        this.parameters.productId = entry.product.id;
      }
      
      if (viewOrigin === "home") {
        this.onChange("home");
      }
      
      if (this.config === "TE" || this.timerMode === "Timer") {
        this.startChrono();
      }
      
      this.parameters.scope = entry.scope;
      let jiraId = entry.jiraId;
      if (jiraId !== "") {
        const regexp = RegExp("^([A-Z0-9]{2,8}-)([0-9]{3,6})$");
        if (regexp.test(jiraId)) {
          let match = jiraId.match(regexp);
          if (match.length >= 2) {
            this.parameters.jiraType = match[1];
            this.parameters.jiraIdNumber = match[2];
          }
        }
      }
      
      this.parameters.entity = entry.entityName;
      
      if (entry.duplicate !== 0) {
        this.parameters.productId = -2;
        this.parameters.duplicate = entry.duplicate;
      }
      
      if (entry.ProductID !== 0) {
        const productStore = useProductStore();
        let doesProductExist = productStore.checkIfProductExist(
          entry.productId,
        );
        if (!doesProductExist) {
          await productStore.fetchProduct(entry.productId);
          this.manDayVisible = true;
        }
        this.parameters.productId = entry.productId;
      } else {
        this.parameters.productId = -1;
      }
      
      this.parameters.manDays = entry.manDays;
      this.errorForm = "";
      this.productChange();
    },

    //duplicate entry feature
    duplicateEntry(key, index, vueEmiting) {
      let entry = [];
      if (vueEmiting === "client") {
        entry = useEntriesStore().entries[key][index];
      } else if (vueEmiting === "home") {
        entry = useUserStore().userEntries[key][index];
      }
      if (this.timerMode === "On") {
        var result = confirm(
          "You did not save the ongoing task, if you continue you will lose your progession. Continue ?",
        );
        if (result) {
          this.stopChrono();
        }
      }
      this.resetChrono();
      this.parameters.entryId = "";
      this.parameters.task = entry.ProjectTask.split(" - ")[1];
      this.parameters.client = entry.ClientID;
      Object.keys(newProjects2).forEach((key) => {
        if (key.includes(this.getProjectNameFromEntry(entry))) {
          this.parameters.project = key;
        }
      });
      if (this.config === "TE" || this.timerMode === "Timer") {
        this.startChrono();
      } else {
        var hours = Math.trunc(entry.Duration);
        var minutes = (entry.Duration - hours) * 60;
        this.parameters.hours = hours;
        this.parameters.minutes = minutes;
      }
      this.parameters.scope = entry.Scope;
      this.billable = entry.Billable;
      this.parameters.description = entry.Description;
      let jiraId = entry.JiraId;
      if (jiraId !== "") {
        const regexp = RegExp("^([A-Z0-9]{2,8}-)([0-9]{3,6})$");
        if (regexp.test(jiraId)) {
          let match = jiraId.match(regexp);
          if (match.length >= 2) {
            this.parameters.jiraType = match[1];
            this.parameters.jiraIdNumber = match[2];
          }
        }
      }
      this.parameters.business_unit = entry.EntityName;
      this.parameters.testId = entry.TestId;
      this.fetchLastEntryByTestId(vueEmiting);
      this.parameters.manDays = entry.ManDays;
      if (entry.Duplicate) {
        this.parameters.productId = -2;
        this.productChange();
        this.parameters.duplicate = entry.Duplicate;
      }
      this.errorForm = "";
    },

    clearParameters() {
      this.stopChrono();
      this.resetChrono();
      this.parameters.task = "";
      this.parameters.client = "";
      this.parameters.project = "";
      this.parameters.duration = 15;
      this.parameters.hours = 0;
      this.parameters.minutes = 15;
      this.parameters.date = new Date();
      this.parameters.description = "";
      this.parameters.business_unit = "";
      this.parameters.jiraIdNumber = "";
      this.parameters.testId = "";
      this.parameters.entryId = "";
      this.parameters.scope = "Web Exp & Perso";
      this.parameters.productId = null;
      this.parameters.manDays = null;
      this.parameters.entity = null;
      this.creditVisible = false;
      this.manDayVisible = false;
      this.errorForm = "";
      this.errorManDay = "";
      this.testIdResult = false;
      this.productListKey = 0;
      this.resetChrono();
      this.fetchEntryByTestIdResult = false;
      this.testIdDisabled = false;
    },

    // chono feature
    startChrono() {
      var self = this;
      this.timerState = "On";
      this.startTime = Date.now();
      self.timer = setInterval(function () {
        self.displayedDuration =
          Math.round((Date.now() - self.startTime) / 1000) + self.duration;
      }, 1000);
    },
    stopChrono() {
      clearInterval(this.timer);
      this.endTime = Date.now();
      this.duration += Math.round((Date.now() - this.startTime) / 1000);
      this.displayedDuration = this.duration;
      this.timerState = "Off";
      var hours = this.duration / 3600;
      var reste = hours % 0.25;
      if (reste !== 0) {
        this.decimalDuration = hours - reste + 0.25;
      } else {
        this.decimalDuration = hours;
      }
    },
    resetChrono() {
      this.duration = 0;
      this.displayedDuration = 0;
      this.decimalTime = 0;
    },

    // action to do when client is chnaged
    onChange: async function (emitingVue) {
      const clientStore = useClientStore();
      this.parameters.entity = null;
      this.parameters.productId = null;
      var id = this.parameters.client;
      let flagOngoingClients = false;
      const resClient = await brogglBack.get("/client/" + id, {
        headers: { Authorization: "Bearer " + window.$cookies.get("jwt") },
      });
      const client = resClient.data.data.client;
      this.entities = client.Entities;
      this.parameters.client = client.ID;
      if (client.Status === "Ongoing" || client.Status === "Late Renewal") {
        flagOngoingClients = true;
      }
      if (
        client.Status === null ||
        client.Name === useUserStore().getUserName()
      ) {
        this.parameters.scope = "n/a";
      }
      let res = {};
      if (emitingVue === "client") {
        res = await brogglBack.get("/product/products/" + id, {
          params: { oppId: clientStore.currContractId },
          headers: { Authorization: "Bearer " + window.$cookies.get("jwt") },
        });
      } else {
        res = await brogglBack.get("/product/products/" + id, {
          headers: { Authorization: "Bearer " + window.$cookies.get("jwt") },
        });
      }
      if (res.data.data) {
        this.products = [];
        this.products = [...this.products, ...res.data.data];
      } else {
        this.products = [];
      }
      window.document.getElementById("entitySelect").disabled = true;
      window.document.getElementById("productSelect").disabled = true;

      if (!!this.entities && this.entities.length !== 0) {
        window.document.getElementById("entitySelect").disabled = false;
      }
      if (this.products == null) {
        this.products = [];
        // this.products.push({
        //   ProductName: 'No package',
        //   ID: -1
        // })
      } else if (flagOngoingClients) {
        // this.products.push({
        //   ProductName: 'No package',
        //   ID: -1
        // })
        this.products.push({
          ProductName: "Duplicate",
          ID: -2,
        });
      }
      if (
        !!this.products &&
        this.products.length !== 0 &&
        flagOngoingClients == true
      ) {
        window.document.getElementById("productSelect").disabled = false;
      }
      this.productChange();
      this.checkIfTestMustDisabled();
    },
    // action to do when project is changed
    taskChanged() {
      if (
        ["Time estimation/Feasibility analysis"].includes(this.parameters.task)
      ) {
        this.parameters.productId = -1;
        this.parameters.creditUse = null;
        this.parameters.manDays = null;
        this.productsDisable = true;
        this.productChange();
      } else {
        this.productsDisable = false;
      }

      if (this.parameters.project === "MUVs") {
        this.parameters.task = "MUVs";
        this.parameters.scope = "n/a";
      }

      if (
        this.parameters.task === "Search & Reco - CS" ||
        this.parameters.task === "Search & Reco - Technical"
      ) {
        this.parameters.scope = "Epoq";
      } else if (this.parameters.task === "EmotionsAI - CS") {
        this.parameters.scope = "EmotionsAI";
      } else if (
        this.parameters.task === "Workshops" &&
        this.parameters.project === "Customer Success"
      ) {
        this.parameters.scope = "Web Exp & Perso";
      }

      this.checkIfTestMustDisabled();

      if (this.parameters.task === "Full day") {
        this.parameters.hours = 8;
        this.parameters.minutes = 0;
      } else if (this.parameters.task === "Half day") {
        this.parameters.hours = 4;
        this.parameters.minutes = 0;
      }

      if (
        this.parameters.project !== "Day Off" &&
        this.parameters.project !== "Platform maintenance and evolution"
      ) {
        return;
      }
    },
    // action to do when project is changed
    clearTask() {
      this.parameters.task = "";
      if (this.projects[this.parameters.project].length === 1) {
        this.parameters.task = this.projects[this.parameters.project][0];
      }
      const naScopes = [
        "Internal Strategy",
        "Admin & HR",
        "Knowledge base",
        "Day Off",
        "KAM activities",
      ];
      if (naScopes.includes(this.parameters.project)) {
        this.parameters.scope = "N/A";
      }
      this.taskChanged();
    },
    // action to do when product is changed
    productChange() {
      let currProductList = [];
      if (this.products.length > 0) {
        currProductList = this.products;
      } else {
        const productStore = useProductStore();
        currProductList = productStore.products;
      }
      currProductList.forEach((product) => {
        if (product.ID === this.parameters.productId) {
          if (this.parameters.productId < 0) {
            this.duplicateField = true;
            this.parameters.duplicate = null;
          } else {
            this.duplicateField = false;
            this.parameters.duplicate = null;
            this.manDayVisible = true;
          }
        }
      });
    },
    // recurrring activities feature
    fillRecurringActivities() {
      switch (this.recurringActivities) {
        case "Recurring Activities":
          this.parameters.client = "";
          this.parameters.hours = 0;
          this.parameters.minutes = 0;
          this.parameters.project = "";
          this.parameters.task = "";
          this.parameters.testId = "";
          this.parameters.jiraIdNumber = "";
          this.parameters.scope = "";
          this.parameters.description = "";
          break;
        case "Big-Up":
          this.setActiveCSM();
          this.parameters.hours = 0;
          this.parameters.minutes = 45;
          this.parameters.project = "Internal Strategy";
          this.parameters.task = "Strategy - other activities";
          this.parameters.testId = "";
          this.parameters.jiraIdNumber = "";
          this.parameters.scope = "n/a";
          this.parameters.description = "Big up";
          break;
        case "1-to-1":
          this.setActiveCSM();
          this.parameters.hours = 1;
          this.parameters.minutes = 0;
          this.parameters.project = "Admin & HR";
          this.parameters.task = "Reviews and other management meetings";
          this.parameters.testId = "";
          this.parameters.jiraIdNumber = "";
          this.parameters.scope = "n/a";
          this.parameters.description = "Weekly 1-to-1";
          break;
        case "Client Team monthly meeting":
          this.setActiveCSM();
          this.parameters.hours = 1;
          this.parameters.minutes = 30;
          this.parameters.project = "Internal Strategy";
          this.parameters.task = "Strategy - other activities";
          this.parameters.testId = "";
          this.parameters.jiraIdNumber = "";
          this.parameters.scope = "n/a";
          this.parameters.description = "Client Team monthly review";
          break;
        case "BYS":
          this.setActiveCSM();
          this.parameters.hours = 0;
          this.parameters.minutes = 45;
          this.parameters.project = "Knowledge base";
          this.parameters.task = "Internal Trainings/BYS/Product updates";
          this.parameters.testId = "";
          this.parameters.jiraIdNumber = "";
          this.parameters.scope = "n/a";
          this.parameters.description = "";
          break;
        case "Campaign analysis":
          this.parameters.hours = 0;
          this.parameters.minutes = 45;
          this.parameters.project = "Professional Services";
          this.parameters.task = "Campaign analysis";
          this.parameters.scope = "Web Exp & Perso";
          break;
        case "Campaign development":
          this.parameters.hours = 1;
          this.parameters.minutes = 30;
          this.parameters.project = "Professional Services";
          this.parameters.task = "Campaign development";
          this.parameters.scope = "Web Exp & Perso";
          break;
        case "Campaign QA":
          this.parameters.hours = 1;
          this.parameters.minutes = 30;
          this.parameters.project = "Professional Services";
          this.parameters.task = "Campaign QA";
          this.parameters.scope = "Web Exp & Perso";
          break;
      }
    },
    setActiveCSM() {
      const userStore = useUserStore();
      if (userStore.name !== null) {
        const activeCsmName = userStore.name;
        if (userStore.clients !== null) {
          const clientsList = userStore.clients;
          if (clientsList.length > 0) {
            clientsList.forEach((client, index) => {
              if (
                Object.prototype.hasOwnProperty.call(client, "name") &&
                Object.prototype.hasOwnProperty.call(client, "id")
              ) {
                if (client.name === activeCsmName) {
                  this.parameters.client = client.id;
                }
              }
            });
          }
        }
      }
    },
    //form validationn feature
    async formValidation() {
      let jiraRes = this.jiraInputValidation();
      let productRes = this.productInputValidation();
      let testIdRes = this.testIdInputValidation();
      let projectTaskRes = this.projectAndTaskInputsValidation();
      let duplicateTestRes = this.duplicationTestValidation();
      let manDaysRes = this.manDaysInputValidation();
      let clientRes = this.clientInputValidation();
      if (this.fetchEntryByTestIdResult && this.parameters.testId !== "") {
        await this.testIdCheck();
      }
      return (
        jiraRes &&
        productRes &&
        testIdRes &&
        projectTaskRes &&
        duplicateTestRes &&
        manDaysRes &&
        clientRes &&
        !this.testIdResult
      );
    },
    getClientId() {
      let clientId = null;
      if (router.currentRoute.value.params.id !== undefined) {
        clientId = router.currentRoute.value.params.id;
      } else if (
        this.parameters.client !== null ||
        this.parameters.client !== undefined
      ) {
        clientId = this.parameters.client;
      }
      return clientId;
    },
    jiraInputValidation() {
      if (this.parameters.jiraIdNumber !== "") {
        this.parameters.jiraId =
          this.parameters.jiraType + this.parameters.jiraIdNumber;
        const regex = RegExp("^([A-Z0-9]{2,8}-)([0-9]{3,6})$");
        if (regex.test(this.parameters.jiraId)) {
          return true;
        } else {
          this.errorForm =
            "The Jira ID must have no more than 5 digits and can't be negative.";
          return false;
        }
      } else {
        this.parameters.jiraId = "";
        return true;
      }
    },
    productInputValidation() {
      if (
        [
          "Workshops",
          "Training",
          "EmotionAI - CS",
          "Search & Reco - CS",
          "Search & Reco - Technical",
          "Ask-TSE",
        ].includes(this.parameters.task)
      ) {
        if (
          this.parameters.productId === null ||
          this.parameters.productId === undefined ||
          this.parameters.productId < 0
        ) {
          if (this.parameters.manDays === null) {
            this.errorForm =
              "Please fill the product field and the Man days field";
          } else {
            this.errorForm = "Please fill the product field";
          }
          return false;
        }
      }
      return true;
    },
    testIdInputValidation() {
      if (this.parameters.testId > 999999999 || this.parameters.testId < 0) {
        this.errorForm =
          "The Test ID must have no more than 10 digits and can't be negative.";
        return false;
      } else if (
        this.parameters.testId !== "" &&
        this.parameters.testId !== null
      ) {
        if (
          this.parameters.productId === null ||
          this.parameters.productId === undefined ||
          this.parameters.productId < 0
        ) {
          this.errorForm =
            "When the test ID input is filled, you have to use a product (if there is no product use the default one)";
          return false;
        }
      } else {
        if (
          this.parameters.testId !== null &&
          this.parameters.testId !== undefined
        ) {
          if (
            this.parameters.productId === null ||
            this.parameters.productId === -1 ||
            this.parameters.productId === -2
          ) {
            if (this.parameters.project === "Professional Services") {
              if (
                [
                  "Campaign development",
                  "Campaign QA",
                  "Campaign analysis",
                ].includes(this.parameters.task)
              ) {
                this.errorForm =
                  "You have to fill the product field when a test ID is provided.";
                return false;
              }
            }
          }
        }
      }
      const regex = RegExp(
        "^([0-9]{1,9}|EMAI[0-9]{0,9}|EPOQ[0-9]{0,9}|WS[0-9]{0,9}|TRAIN[0-9]{0,9}|MUV[0-9]{0,9})$",
      );
      if (!regex.test(this.parameters.testId) && this.parameters.lenght > 0) {
        this.errorForm =
          'The Test ID must have no more than 9 digits and only contains those prefixes: "EMAI", "EPOQ", "WS", "TRAIN", "MUV".';
        return false;
      }
      return true;
    },
    projectAndTaskInputsValidation() {
      if (
        this.parameters.project === "Admin & HR" &&
        this.parameters.task === "Other"
      ) {
        if (this.parameters.description === "") {
          this.errorForm = "Please fill the description field";
          return false;
        }
      } else if (
        ["Campaign development", "Campaign QA", "Test review"].includes(
          this.parameters.task,
        )
      ) {
        if (this.parameters.testId === "") {
          this.errorForm =
            "Please fill the test ID field when logging this task";
          return false;
        }
      }
      return true;
    },
    duplicationTestValidation() {
      if (this.parameters.duplicate) {
        if (this.parameters.duplicate.lenght > 6) {
          this.errorForm =
            'The "Duplicated from test ID" field cannot exceed 6 digits';
          return false;
        }
      }
      return true;
    },
    manDaysInputValidation() {
      if (this.manDayVisible && this.parameters.manDays === null) {
        this.errorForm = "You have to fill the man-days field";
        return false;
      }
      return true;
    },
    clientInputValidation() {
      if (this.fetchEntryByTestIdResult === true) {
        if (this.fetchedEntryByTestId.clientId !== this.parameters.client) {
          this.errorForm =
            "The client does not match the client owning this test ID";
          return false;
        }
      }
      return true;
    },
    replaceProductId(productId) {
      if (productId === -1 || productId === -2 || productId === -3) {
        this.parameters.productId = null;
      }
    },
    computeDuration() {
      if (this.timerState === "On") {
        this.stopChrono();
      }
      const timerMode = useUserStore().timerMode;
      if (timerMode === "Timer") {
        this.parameters.duration = this.decimalDuration;
      } else if (timerMode === "Normal") {
        this.parameters.duration =
          this.parameters.minutes / 60 + this.parameters.hours;
      }
    },
    cleanErrorMessages() {
      this.errorForm = "";
      this.errorManDay = "";
      this.error = "";
    },
    checkIfTestMustDisabled() {
      if (
        this.parameters.scope === "Epoq" ||
        this.parameters.scope === "EmotionsAI" ||
        (this.parameters.task === "Workshops" &&
          this.parameters.project === "Customer Success") ||
        (this.parameters.project === "MUVs" &&
          this.parameters.task === "MUVs") ||
        (this.parameters.project === "Customer Success" &&
          this.parameters.task === "Training") ||
          this.parameters.client === 65542
          // BAsSpecificTasks.includes(this.parameters.task)
      ) {
        this.testIdDisabled = true;
      } else {
        this.testIdDisabled = false;
      }
    },
    checkIfViewIsMobile() {
      if (window.innerWidth < 1024) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },
    getProjectNameFromEntry(entry) {
      switch (entry.ProjectTask.split(" - ")[0]) {
        case "PS":
          return "Professional Services";
          break;
        case "CS":
          return "Customer Success";
          break;
        case "Onb":
          return "Onboarding";
          break;
        case "Int":
          return "Internal Strategy";
          break;
        case "KB":
          return "Knowledge base";
          break;
        case "Bug":
          return "Debug";
          break;
        case "Pro":
          return "Product activities";
          break;
        case "Mkt":
          return "Marketing activities";
          break;
        case "Sal":
          return "Sales activities";
          break;
        case "KAM":
          return "KAM activities";
          break;
        case "Adm":
          return "Admin & HR";
          break;
        case "PSM":
          return "Partners";
          break;
        case "Off":
          return "Day Off";
          break;
        case "BR":
          return "Balance recovery";
          break;
        case "MUVs":
          return "MUVs";
          break;
      }
    },
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useFormStore, import.meta.hot));
}
